__turbopack_context__.v({
  "container": "PlaygroundTimeline-module__6b5Ysq__container",
  "dateText": "PlaygroundTimeline-module__6b5Ysq__dateText",
  "endCircle": "PlaygroundTimeline-module__6b5Ysq__endCircle",
  "itemDetails": "PlaygroundTimeline-module__6b5Ysq__itemDetails",
  "itemDetailsContainer": "PlaygroundTimeline-module__6b5Ysq__itemDetailsContainer",
  "itemTitle": "PlaygroundTimeline-module__6b5Ysq__itemTitle",
  "nonEssenceCircle": "PlaygroundTimeline-module__6b5Ysq__nonEssenceCircle",
  "originCircle": "PlaygroundTimeline-module__6b5Ysq__originCircle",
  "startEndText": "PlaygroundTimeline-module__6b5Ysq__startEndText",
  "stayCircle": "PlaygroundTimeline-module__6b5Ysq__stayCircle",
  "timelineContainer": "PlaygroundTimeline-module__6b5Ysq__timelineContainer",
  "timelineIconCircle": "PlaygroundTimeline-module__6b5Ysq__timelineIconCircle",
  "timelineItem": "PlaygroundTimeline-module__6b5Ysq__timelineItem",
  "timelineLine": "PlaygroundTimeline-module__6b5Ysq__timelineLine",
  "timelineList": "PlaygroundTimeline-module__6b5Ysq__timelineList",
});
